var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "create-share-person",
        title: "Share Person",
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: _vm.showModal,
        centered: ""
      },
      on: { hidden: _vm.reset },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Share all associated components of this person record (e.g., screenings, notes, advocates, and external ids) with a group.\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "b-list-group",
        { attrs: { flush: "" } },
        _vm._l(_vm.userGroups, function(group) {
          return _c(
            "b-list-group-item",
            { key: group.id },
            [
              _c("span", [_vm._v(_vm._s(_vm._.get(group, "groupName", "")))]),
              _vm._v(" "),
              _vm.isAllowedToSharePerson
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        type: "button",
                        variant: "outline-primary",
                        size: "sm"
                      },
                      on: {
                        click: function($event) {
                          return _vm.shareHandler(group)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "button-text" }, [
                        _vm._v("Share")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            dismissible: "",
            fade: "",
            show: !_vm._.isEmpty(_vm.sharePersonResponse),
            variant: _vm.sharePersonResponse.error ? "danger" : "success"
          }
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.apiResponseMessage(_vm.sharePersonResponse))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bde6e15", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bde6e15","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/CreateSharePersonModal.vue
// module id = 1593
// module chunks = 0